import { platformGetMeQueryKey, platformPatchMeMutation } from "@manapp/api-client"
import { SUPPORTED_LANGUAGES, Select, isLanguage, useTranslation } from "@manapp/ui"
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { setApiLanguage } from "../api"

/** Saves the user's language preference (it follows the user across devices). */
export function LanguageSwitcher() {
  const { t, i18n } = useTranslation()
  const queryClient = useQueryClient()
  const save = useMutation({
    ...platformPatchMeMutation(),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: platformGetMeQueryKey() }),
  })
  return (
    <Select
      size="small"
      value={i18n.language}
      onValueChange={(language) => {
        if (!isLanguage(language)) return
        void i18n.changeLanguage(language)
        setApiLanguage(language)
        save.mutate({ body: { language } })
      }}
    >
      <Select.Trigger aria-label={t("language.label")} className="w-32">
        <Select.Value />
      </Select.Trigger>
      <Select.Content>
        {SUPPORTED_LANGUAGES.map((language) => (
          <Select.Item key={language} value={language}>
            {t(`language.${language}`)}
          </Select.Item>
        ))}
      </Select.Content>
    </Select>
  )
}
